import { _ as _defineProperty } from '../defineProperty-2d1aa32d.js';
import { Gradients } from '@picsart/design-system/foundation/colors';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var BreakPoints = {
  ExtraLarge: 1365,
  Large: 1023,
  Medium: 767,
  Small: 766
};
var OldBreakPoints = /*#__PURE__*/function (OldBreakPoints) {
  OldBreakPoints[OldBreakPoints["xsmall"] = 375] = "xsmall";
  OldBreakPoints[OldBreakPoints["xlsmall"] = 576] = "xlsmall";
  OldBreakPoints[OldBreakPoints["small"] = 767] = "small";
  OldBreakPoints[OldBreakPoints["medium"] = 1024] = "medium";
  OldBreakPoints[OldBreakPoints["large"] = 1281] = "large";
  OldBreakPoints[OldBreakPoints["xlarge"] = 1366] = "xlarge";
  OldBreakPoints[OldBreakPoints["xxlarge"] = 1600] = "xxlarge";
  return OldBreakPoints;
}({});
var mediaQuery = function mediaQuery(breakPoint) {
  return "@media screen and (max-width: ".concat(breakPoint, "px)");
};
var mediaQueryMin = function mediaQueryMin(breakPoint) {
  return "@media screen and (min-width: ".concat(breakPoint, "px)");
};
var textBgClip = {
  WebkitTextFillColor: 'transparent',
  MozTextFillColor: 'transparent',
  textFillColor: 'transparent',
  WebkitBackgroundClip: 'text',
  MozBackgroundClip: 'text',
  backgroundClip: 'text'
};
var textBackgroundPro = _objectSpread(_objectSpread({}, textBgClip), {}, {
  backgroundImage: Gradients.pro
});
var textBackgroundPlus = _objectSpread(_objectSpread({}, textBgClip), {}, {
  backgroundImage: Gradients.plus
});
var textBackgroundGold = _objectSpread(_objectSpread({}, textBgClip), {}, {
  backgroundImage: Gradients.gold
});
var helpers = {
  textBackgroundPlus: textBackgroundPlus,
  textBackgroundPro: textBackgroundPro,
  OldBreakPoints: OldBreakPoints,
  mediaQueryMin: mediaQueryMin,
  BreakPoints: BreakPoints,
  mediaQuery: mediaQuery
};

export { BreakPoints, OldBreakPoints, helpers as default, mediaQuery, mediaQueryMin, textBackgroundGold, textBackgroundPlus, textBackgroundPro, textBgClip };
//# sourceMappingURL=index.js.map
